import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StatusIndicator from '../StatusIndicator';
import debounce from 'lodash/debounce';
import isNaN from 'lodash/isNaN';
import styles from './InputArea.scss';
import { dataHooks } from './constants';
/**
 * General inputArea container
 */

var InputArea = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(InputArea, _React$PureComponent);

  var _super = _createSuper(InputArea);

  function InputArea() {
    var _this;

    _classCallCheck(this, InputArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_computedStyle", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false,
      counter: (_this.props.value || _this.props.defaultValue || '').length,
      computedRows: _this.props.minRowsAutoGrow
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.textArea && _this.textArea.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.textArea && _this.textArea.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "select", function () {
      _this.textArea && _this.textArea.select();
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (e) {
      _this.setState({
        focus: true
      });

      _this.props.onFocus && _this.props.onFocus(e);

      if (_this.props.autoSelect) {
        // Set timeout is needed here since onFocus is called before react
        // gets the reference for the input (specifically when autoFocus
        // is on. So setTimeout ensures we have the ref.input needed in select)
        setTimeout(function () {
          return _this.select();
        }, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (e) {
      _this.setState({
        focus: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (e) {
      _this.props.onKeyDown && _this.props.onKeyDown(e);

      if (e.key === 'Enter') {
        _this.props.onEnterPressed && _this.props.onEnterPressed(e);
      } else if (e.key === 'Escape') {
        _this.props.onEscapePressed && _this.props.onEscapePressed();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (e) {
      _this.props.onChange && _this.props.onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function () {
      _this._calculateComputedRows();
    });

    _defineProperty(_assertThisInitialized(_this), "_calculateComputedRows", function () {
      _this.setState({
        computedRows: 1
      }, function () {
        var rowsCount = _this._getRowsCount();

        var computedRows = Math.max(_this.props.minRowsAutoGrow, rowsCount);

        _this.setState({
          computedRows: computedRows
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_updateComputedStyle", debounce(function () {
      _this._computedStyle = window.getComputedStyle(_this.textArea);
    }, 500, {
      leading: true
    }));

    _defineProperty(_assertThisInitialized(_this), "_getComputedStyle", function () {
      _this._updateComputedStyle();

      return _this._computedStyle;
    });

    _defineProperty(_assertThisInitialized(_this), "_getRowsCount", function () {
      var computedStyle = _this._getComputedStyle();

      var fontSize = parseInt(computedStyle.getPropertyValue('font-size'), 10);
      var lineHeight = parseInt(computedStyle.getPropertyValue('line-height'), 10);
      var lineHeightValue;

      if (isNaN(lineHeight)) {
        if (isNaN(fontSize)) {
          return InputArea.MIN_ROWS;
        }

        lineHeightValue = _this._getDefaultLineHeight() * fontSize;
      } else {
        lineHeightValue = lineHeight;
      }

      return Math.floor(_this.textArea.scrollHeight / lineHeightValue);
    });

    _defineProperty(_assertThisInitialized(_this), "_getDefaultLineHeight", function () {
      if (!_this._defaultLineHeight) {
        var parentNode = _this.textArea.parentNode;

        var computedStyles = _this._getComputedStyle();

        var fontFamily = computedStyles.getPropertyValue('font-family');
        var fontSize = computedStyles.getPropertyValue('font-size');
        var tempElement = document.createElement('span');
        var defaultStyles = 'position:absolute;display:inline;border:0;margin:0;padding:0;line-height:normal;';
        tempElement.setAttribute('style', "".concat(defaultStyles, "font-family:").concat(fontFamily, ";font-size:").concat(fontSize, ";"));
        tempElement.innerText = 'M';
        parentNode.appendChild(tempElement);
        _this._defaultLineHeight = parseInt(tempElement.clientHeight, 10) / parseInt(fontSize, 10);
        tempElement.parentNode.removeChild(tempElement);
      }

      return _this._defaultLineHeight;
    });

    return _this;
  }

  _createClass(InputArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          autoGrow = _this$props.autoGrow;
      autoFocus && this._onFocus();

      if (autoGrow) {
        this._calculateComputedRows();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.autoGrow && prevProps.minRowsAutoGrow !== this.props.minRowsAutoGrow) {
        this._calculateComputedRows();
      }

      if (this.props.hasCounter && prevProps.value !== this.props.value) {
        this.setState({
          counter: (this.props.value || this.props.defaultValue || '').length
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._updateComputedStyle.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          dataHook = _this$props2.dataHook,
          autoFocus = _this$props2.autoFocus,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          forceFocus = _this$props2.forceFocus,
          forceHover = _this$props2.forceHover,
          id = _this$props2.id,
          name = _this$props2.name,
          onKeyUp = _this$props2.onKeyUp,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          tabIndex = _this$props2.tabIndex,
          rows = _this$props2.rows,
          autoGrow = _this$props2.autoGrow,
          value = _this$props2.value,
          required = _this$props2.required,
          minHeight = _this$props2.minHeight,
          maxHeight = _this$props2.maxHeight,
          maxLength = _this$props2.maxLength,
          resizable = _this$props2.resizable,
          hasCounter = _this$props2.hasCounter,
          size = _this$props2.size,
          tooltipPlacement = _this$props2.tooltipPlacement,
          status = _this$props2.status,
          statusMessage = _this$props2.statusMessage;
      var inlineStyle = {};
      var rowsAttr = rows ? rows : autoGrow ? this.state.computedRows : undefined;
      var onInput = !rows && autoGrow ? this._onInput : undefined;

      if (minHeight) {
        inlineStyle.minHeight = minHeight;
      }

      if (maxHeight) {
        inlineStyle.maxHeight = maxHeight;
      }

      var classes = classNames((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.hasStatus, !!status), _defineProperty(_classNames, styles.hasError, status === 'error'), _defineProperty(_classNames, styles.hasWarning, status === 'warning'), _defineProperty(_classNames, styles.hasHover, forceHover), _defineProperty(_classNames, styles.hasFocus, forceFocus || this.state.focus), _defineProperty(_classNames, styles.resizable, !!resizable), _defineProperty(_classNames, styles.nonResizable, !resizable || !!disabled), _defineProperty(_classNames, styles.disabled, !!disabled), _classNames));
      var ariaAttribute = {};
      Object.keys(this.props).filter(function (key) {
        return key.startsWith('aria');
      }).map(function (key) {
        return ariaAttribute['aria-' + key.substr(4).toLowerCase()] = _this2.props[key];
      });
      var inputAreaClasses = classNames(styles.inputArea, _defineProperty({}, styles.sizeSmall, size === 'small'));
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: styles.wrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("textarea", _extends({
        rows: rowsAttr,
        maxLength: maxLength,
        ref: function ref(_ref) {
          return _this2.textArea = _ref;
        },
        className: inputAreaClasses,
        id: id,
        name: name,
        style: inlineStyle,
        defaultValue: defaultValue,
        disabled: disabled,
        value: value,
        required: required,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onKeyDown: this._onKeyDown,
        onChange: this._onChange,
        onInput: onInput,
        placeholder: placeholder,
        tabIndex: tabIndex,
        autoFocus: autoFocus,
        onKeyUp: onKeyUp
      }, ariaAttribute, {
        readOnly: readOnly
      })), hasCounter && maxLength && /*#__PURE__*/React.createElement("span", {
        className: styles.counter,
        "data-hook": "counter"
      }, this.state.counter, "/", maxLength)), /*#__PURE__*/React.createElement("div", {
        className: styles.status
      }, !!status && !disabled && /*#__PURE__*/React.createElement(StatusIndicator, {
        dataHook: dataHooks.tooltip,
        status: status,
        message: statusMessage,
        tooltipPlacement: tooltipPlacement
      })));
    }
  }]);

  return InputArea;
}(React.PureComponent);

_defineProperty(InputArea, "MIN_ROWS", 2);

InputArea.displayName = 'InputArea';
InputArea.defaultProps = {
  minRowsAutoGrow: InputArea.MIN_ROWS,
  size: 'normal'
};
InputArea.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  ariaControls: PropTypes.string,
  ariaDescribedby: PropTypes.string,

  /** Used to define a string that labels the current element in case where a text label is not visible on the screen. */
  ariaLabel: PropTypes.string,

  /** Standard React Input autoFocus (focus the element on mount) */
  autoFocus: PropTypes.bool,

  /** Standard React Input autoSelect (select the entire text of the element on focus) */
  autoSelect: PropTypes.bool,

  /** Specifies the size of the input */
  size: PropTypes.oneOf(['small', 'normal']),

  /** Default value for those who wants to use this component un-controlled */
  defaultValue: PropTypes.string,

  /** Disables the input */
  disabled: PropTypes.bool,

  /** Sets UI to indicate a status */
  status: PropTypes.oneOf(['error', 'warning', 'loading']),

  /** The status message to display when hovering the status icon, if not given or empty there will be no tooltip */
  statusMessage: PropTypes.node,
  forceFocus: PropTypes.bool,
  forceHover: PropTypes.bool,

  /** When true a letters counter will appear */
  hasCounter: PropTypes.bool,
  id: PropTypes.string,

  /** Name Attribute */
  name: PropTypes.string,

  /** i.e. '12px' */
  maxHeight: PropTypes.string,

  /** Define max length allowed in the inputArea */
  maxLength: PropTypes.number,
  menuArrow: PropTypes.bool,

  /** i.e. '12px' */
  minHeight: PropTypes.string,

  /** onBlur callback */
  onBlur: PropTypes.func,

  /** onChange callback */
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onEnterPressed: PropTypes.func,
  onEscapePressed: PropTypes.func,

  /** onFocus callback */
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,

  /** Placeholder to display */
  placeholder: PropTypes.string,

  /** Sets the input to readOnly */
  readOnly: PropTypes.bool,
  resizable: PropTypes.bool,

  /** Sets initial height according to the number of rows (chrome uses the rows for minHeight as well) */
  rows: PropTypes.number,

  /** Will cause the Input Area to grow and shrink according to user input */
  autoGrow: PropTypes.bool,

  /** Sets the minimum amount of rows the component can have when in autoGrow mode */
  minRowsAutoGrow: PropTypes.number,
  tabIndex: PropTypes.number,

  /** Placement of the status tooltip */
  tooltipPlacement: PropTypes.string,

  /** Inputs value */
  value: PropTypes.string,

  /** Makes textarea required during form submission */
  required: PropTypes.bool
};
export default InputArea;